var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6673 6.66634C8.9059 6.66634 6.66732 8.90492 6.66732 11.6663V28.333C6.66732 31.0945 8.9059 33.333 11.6673 33.333H28.334C31.0955 33.333 33.334 31.0945 33.334 28.333V18.333C33.334 17.4125 34.0802 16.6663 35.0007 16.6663C35.9212 16.6663 36.6673 17.4125 36.6673 18.333V28.333C36.6673 32.9353 32.9363 36.6663 28.334 36.6663H11.6673C7.06495 36.6663 3.33398 32.9353 3.33398 28.333V11.6663C3.33398 7.06397 7.06495 3.33301 11.6673 3.33301H21.6673C22.5878 3.33301 23.334 4.07921 23.334 4.99967C23.334 5.92014 22.5878 6.66634 21.6673 6.66634H11.6673Z",
    fill: "#00504E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6933 4.70114C29.5693 3.82514 30.7575 3.33301 31.9963 3.33301C33.2352 3.33301 34.4232 3.82514 35.2992 4.70114C36.1752 5.57714 36.6673 6.76524 36.6673 8.00409C36.6673 9.24294 36.1752 10.4311 35.2992 11.3071L33.994 12.6123C33.3432 13.2632 32.2878 13.2632 31.637 12.6123L27.388 8.36341C26.7372 7.71252 26.7372 6.65726 27.388 6.00637L28.6933 4.70114ZM25.031 10.7204C24.3802 10.0695 23.3248 10.0695 22.674 10.7204L15.2385 18.156C15.0249 18.3695 14.8734 18.6372 14.8001 18.9302L13.3838 24.5955C13.2418 25.1633 13.4082 25.7642 13.8222 26.1782C14.2361 26.5922 14.837 26.7585 15.4049 26.6165L21.0702 25.2003C21.3632 25.127 21.6308 24.9755 21.8443 24.7618L29.28 17.3263C29.9308 16.6755 29.9308 15.6202 29.28 14.9693L25.031 10.7204Z",
    fill: "#00504E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.275cbba6967c8027535be1f09815e0f5.svg";
export { ForwardRef as ReactComponent };